import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaEye, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { Button } from "../../components/ui/button";
import { DataTable } from "../../components/DataTable";
import useUserStore from "../../stores/userStore";
import useUserStore2 from "../../stores/userStore2";
import {requestService, requestDataMap, membershipService, membershipDataMap} from "../../services";
import Modal from "../../components/Modal";
import ShortenedText from "../../components/ShortenedText.js";
import { toast } from "react-toastify";
import { createItemStore } from "../../stores/createItemStore";
import LoadingImage from "../../components/LoadingImage";
import StatusBadge from "../../components/table/StatusBadge"

const columns = [
  {
    accessorKey: "dateCreated",
    header: "Date",
    cell: ({ row }) => <span>{row.getValue("dateCreated").split(",")[0]}</span>,
  },
  {
    accessorKey: "requestId",
    header: "Request ID",
    cell: ({ row }) => (
      <span>
        <ShortenedText text={row.getValue("requestId")} />
      </span>
    ),
  },
  {
    accessorKey: "type",
    header: "Type",
    cell: ({ row }) => {
      const type = row.getValue("type");
      return (
        <div className="px-4 py-2 text-sm text-[#111827]">
          <span
            className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${
              type === "Invitation"
                ? "text-green-600 bg-white border border-green-600"
                : type === "Activation"
                ? "text-blue-600 bg-white border border-blue-500"
                : type === "Suspension"
                ? "text-[#EF4444] bg-white border border-red-500"
                : "text-gray-500 bg-white border border-gray-500"
            }`}
          >
            {type}
          </span>
        </div>
      );
    },
  },
  // {
  //   accessorKey: "groupLeader",
  //   header: "Group Leader",
  //   cell: ({ row }) => <span>{row.getValue("groupLeader")}</span>,
  // },
  {
    accessorKey: "targetProfile",
    header: "Target",
    cell: ({ row }) => {
      return (
        <span>
          {}
          {row.getValue("targetProfile")}
          {row.getValue("targetProfile") && row.original.targetEmail && <br />}
          {(row.original.targetEmail || row.original.email) && (
            <>{row.original.targetEmail || row.original.email}</>
          )}
          {!row.original.targetProfile &&
            !row.original.email &&
            row.original.profileName && <>{row.original.profileName} (self)</>}
        </span>
      );
    },
  },
  {
    accessorKey: "communityName",
    header: "Community/Group Name",
    cell: ({ row }) => {
      return (
        <span>
          {row.getValue("communityName")}
          {row.original.groupName && (
            <>
              <br />({row.original.groupName})
            </>
          )}
        </span>
      );
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <StatusBadge status={status} />
      );
    },
  },
];

// ========================================================
// Step 1: Zustand store instantiation
// ========================================================
const storeName = "requests";
const useItems = createItemStore(
  storeName,
  (request) => request.requestId,
  (args) => requestService.getRequests(args[0], args[1], args[2], args[3]),
  requestDataMap
);

const useMemberships = createItemStore(
  "memberships",
  (membership) => membership.membershipId,
  (args) => membershipService.getMembershipByCommunity(args[0]),
  membershipDataMap
);
// ========================================================

const CommRequests = () => {
  const navigate = useNavigate();
  const [showApprovemodal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false); //
  const [requestsToApprove, setRequestsToApprove] = useState([]);
  const [requestsToReject, setRequestsToReject] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  // const { communityId } = useUserStore();
  const { communityId } = useParams();

  // Handles opening the approval modal with selected request ID
  const handleApproveClick = (requestId) => {
    setRequestsToApprove([requestId]); // Store the request to be approved
    setShowApproveModal(true);
  };

  // Handles confirming approval of one or more requests
  const handleConfirmApprove = async () => {
    if (!requestsToApprove.length) {
      console.error("No requests selected for approval.");
      return;
    }

    setLoading(true);

    try {
      for (const requestId of requestsToApprove) {
        console.log("Approving request:", requestId);
        await requestService.acceptRequest({
          RequestId: requestId,
        });

        // Check if request is a removal request, if so remove membership from indexdb
        const request = getSortedFiltered((request) => request.requestId === requestId)[0];
        console.log("Request:", request);

        // If request type is R for removal, then remove Membership from memberships indexdb storage
        if (request.type === "Removal") {

          console.log("requestProfileId:", request.requestProfileId);

          const membership = getMemberships((membership) =>
            membership.profileId === request.requestProfileId
            && membership.communityId === request.communityId
          );

          if (membership.length > 0) {
            console.log("Removing membership:", membership);
            removeMembership(membership[0].membershipId);
          } else {
            console.log("No membership found for membership removal");
          }
        }

      }

      toast.success("🎉 Request approved successfully!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Failed to approve request:", error);
      toast.error("❌ Failed to approve request", {
        autoClose: 2000,
      });
    } finally {
      setReload(!reload); // Reload regardless of success or failure
      setShowApproveModal(false);
      setRequestsToApprove([]);
      setLoading(false);
    }
  };

  const handleRejectClick = (requestId) => {
    setRequestsToReject([requestId]); // Store the request to be rejected
    setShowRejectModal(true);
  };

  // Handles confirming rejection of one or more requests
  const handleConfirmReject = async () => {
    if (!requestsToReject.length) {
      console.error("No requests selected for rejection.");
      return;
    }

    setLoading(true);

    try {
      for (const requestId of requestsToReject) {
        console.log("Rejecting request:", requestId);
        await requestService.rejectRequest({
          RequestId: requestId,
          Comment: "", // You can add a comment field in the modal if needed
        });
      }

      toast.success("🎉 Request Rejected successfully!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Failed to reject request:", error);
      toast.error("❌ Failed to reject request", {
        autoClose: 2000,
      });
    } finally {
      setReload(!reload); // Reload data
      setShowRejectModal(false);
      setRequestsToReject([]); // Clear the selected requests
      setLoading(false);
    }
  };

  // Table row actions
  const actions = (row) => [
    {
      label: "View Details",
      icon: <FaEye />,
      onClick: () => navigate(`/ca/pending/view/${row.requestId}`),
      variant: "dropPlain",
    },
    {
      label: "Approve",
      icon: <FaCheckCircle />,
      onClick: () => handleApproveClick(row.requestId),
      variant: "dropGreen",
    },
    {
      label: "Reject",
      icon: <FaTimesCircle />,
      onClick: () => handleRejectClick(row.requestId),
      variant: "dropRed",
    },
  ];

  // const getAllRequests = ServiceOnMount(
  //   () =>
  //     requestService.getRequests(undefined, undefined, undefined, communityId),
  //   requestDataMap,
  //   [communityId, reload]
  // );

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================
  const { isLoading, fetchItems, getSortedFiltered } = useItems(
    (state) => state
  );
  const data = getSortedFiltered(
    (request) =>
      request.status === "Pending" &&
      request.communityId === communityId
  );
  const showLoading = data.length === 0 && isLoading;
  console.log(`${storeName}:`, data);
  useEffect(() => {
    fetchItems({}, [undefined, undefined, undefined, communityId]);
  }, [communityId, reload]);

  // Accessing memberships store in case we need to remove membership
  const { getSortedFiltered: getMemberships, removeItem: removeMembership } =
    useMemberships((state) => state);

  // ========================================================

  // // Zustand store setup: Step 3 - After ServiceOnMount
  // if (getAllRequests?.data)
  //   if (communityId) {
  //     setPage((state) => {
  //       if (!state.requestsTable) state.requestsTable = {};
  //       if (!state.requestsTable.community) state.requestsTable.community = {};
  //       state.requestsTable.community[communityId] = getAllRequests.data;
  //       return state;
  //     });
  //   }
  //
  // const filteredRequests = useMemo(() => {
  //   return !isRequestTableEmpty(page, "community", communityId)
  //     ? page.requestsTable.community[communityId].filter(
  //         (item) =>
  //           item?.communityId === communityId &&
  //           item?.status === "Pending" &&
  //           item?.type !== "T" // Exclude type "T"
  //       )
  //     : [];
  // }, [getAllRequests.data, communityId]);

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 p-4 sm:p-8">
          <div className="bg-white shadow rounded-lg md:max-w-[calc(100vw-375px)] p-4 sm:p-6 text-sm mt-6">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
              <div className="text-lg font-semibold text-[#111827] mb-4 sm:mb-0">
                Pending Requests List
              </div>
            </div>
            <hr />
            <div className="overflow-x-auto w-full max-w-screen-lg">
              {/*{getAllRequests.loading &&*/}
              {showLoading ? (
                // isRequestTableEmpty(page, "community", communityId) ? (
                <LoadingImage />
              ) : data.length > 0 ? (
                // ) : !isRequestTableEmpty(page, "community", communityId) ? (
                <DataTable columns={columns} data={data} actions={actions} />
              ) : (
                <div className="text-center text-gray-500 py-6">
                  No requests found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Approve modal */}
      <Modal
        isOpen={showApprovemodal}
        onClose={() => setShowApproveModal(false)}
        title="Approve Request"
        description="Are you sure you want to approve this request?"
        icon={<FaCheckCircle className="text-green-500" />}
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => setShowApproveModal(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleConfirmApprove} disabled={loading}>
              {loading ? "Approving..." : "Approve"}{" "}
            </Button>
          </div>
        }
      />

      {/* Reject Request Modal */}
      <Modal
        isOpen={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        title="Reject Request"
        description="Are you sure you want to reject this request?"
        icon={<FaTimesCircle className="text-red-500" />}
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => setShowRejectModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={handleConfirmReject}
              disabled={loading}
            >
              {loading ? "Rejecting..." : "Reject"}{" "}
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default CommRequests;
